import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Solutions } from './components/Solutions';
import { Results } from './components/Results';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-navy-900 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Solutions data-id="element-5" />
        <Results data-id="element-6" />
        <Process data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Pricing data-id="element-9" />
        <CtaSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}